export default __webpack_public_path__ + "static/media/intro-tubulin.9bc41943.png";